export function facetsQuery(params) {
    return JSON.stringify({
        query: `
            query Facets(
                $categoryIds: [ID],
            ) {
                facets(
                    categoryIds: $categoryIds,
                )  {
                    id
                    title
                    facetOptions {
                        id
                        title
                    }
                }
            }
        `,
        variables: params,
    });
}
